import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { MessageService } from 'primeng/api';

import { ConfigService } from './services/config.service';
import {Message} from './models/message';
import {environment} from '../../assets/environment';
import {Severity} from './models/severity';



@Injectable()
export class EventService {

    /**
     * api endpoint
     */
    private logRemoteURL = 'v1/log/';
    /**
     * message list
     */
    messages: Message[] = [];
    /**
     * constructor
     * @param http httpclient from @angular/common/http
     */
    constructor(
        private messageService: MessageService,
        private http: HttpClient
    ) { }

    /**
     * send log message to remote server (api) in order to catch local issues
     * @param operation operation which has been executed
     * @param message error message
     */
    logRemote(operation: string, message: string) {
        const msg = { operation: operation, message: btoa(message) };
        const options = { headers: { 'X-EVENT-MSG': btoa(JSON.stringify(message)) } };
        return this.http.post<Message>(ConfigService.getApiEndpoint() + this.logRemoteURL, operation, options).pipe();
    }

    /**
     * log message to console
     * @param message message to display
     */
    logConsole(message: string) {
        if (!environment.production) {
            console.log(message);
        }
    }

    /**
     * display logmessage in web frontend
     * @param message message to display
     * @param severity (optional) severity class for the message, (default Severity.INFO)
     * @param timeout (optional) timeout until message will disappear, (default 3000 ms)
     */


    addAlert(message: string, severity = Severity.INFO, timeout = 3000) {
        this.addAlertNew(severity, message, severity, timeout);
    }

    addAlertNew(summary: string, detail: string, severity = Severity.INFO, timeout = 3000) {
        const msg = { id: this.generateID(), summary: summary, detail: detail, severity: severity };
        this.messageService.add(msg);
        setTimeout(() => {
            this.clear(msg);
        }, timeout);

    }
    /**
     * wrapper for add(message, Severity.DANGER);
     * @param message message to display
     */
    error(message) {
        this.addAlert(message, Severity.DANGER);
    }

    /**
    * wrapper for add(message, Severity.INFO);
    * @param message message to display
    */
    info(message) {
        this.addAlert(message, Severity.INFO);
    }

    /**
    * wrapper for add(message, Severity.SUCCESS);
    * @param message message to display
    */
    success(message) {
        this.addAlert(message, Severity.SUCCESS);
    }

    /**
    * wrapper for add(message, Severity.WARN);
    * @param message message to display
    */
    warn(message) {
        this.addAlert(message, Severity.WARN);
    }

    /**
     * clear all log message from backoffice
     */
    clearAll() {
        this.messages = [];
    }

    /**
     * delete a single message from backoffice
     * @param msg message object to be deleted
     */
    clear(msg: Message) {
        this.messages.forEach((item, index) => {
            if (item.id === msg.id) {
                this.messages.splice(index, 1);
            }
        });
    }

    /**
     * generate a unique id per message in format
     * "random(1000,9999)-timestamp"
     */
    private generateID(): string {
        return Math.floor(Math.random() * 1000) + '-' + new Date().getTime();
    }
}
